
















































































































import { Vue, Component } from 'vue-property-decorator';
import * as api from '@/api';
import { dxSettingMap } from '@/config/map.conf';
import DxSettingMemberGroup from './dxMemberGroup.vue';
@Component({
    components: {
        DxSettingMemberGroup
    }
})
export default class DxSetting extends Vue {
    settingForm: any = {
        external: false,
        inviteCc: false,
        addCc: false,
        welcomeMessage: true,
        assignedUpdate: true,
        ticketReminder: false,
        associateSystemReminder: true,
        satisfyReminder: true,
        reopenReminder: true,
        dissolveGroupSwitch: false,
        ticketReminderTime: 12.0, // 注意这个要带小数点
        satisfyReminderMethod: 'OFFICIAL_ACCOUNT',
        reopenReminderMethod: 'OFFICIAL_ACCOUNT', // 公众号
        associateSystemReminderMethod: 'CHATROOM_CARD', // 消息卡片
        assignedUpdateReminderMethod: 'CHATROOM_CARD', // 消息卡片
        associateSystemAdditionalReceiver: [],
        autoCreateGroup: false, // 是否自动建群
        inviteThirdPartyRobotSwitch: false, // 是否绑定业务机器人
        thirdPartyRobotCtiList: [
            {
                robotId: null,
                itemList: []
            }
        ]
    };
    contentMap: any[] = dxSettingMap;
    categoryList = [];
    showErrorTip: boolean = false;

    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
    showReciever(item) {
        const needReceiverList = ['associateSystemReminder', 'pauseReminder', 'descUpdateReminder'];
        return needReceiverList.includes(item.key) && this.settingForm[item.radioKey] === 'OFFICIAL_ACCOUNT';
    }
    created() {
        this.getDxSetting();
        this.getCtiByRgUnfold();
    }
    addBotLine() {
        this.$set(this.settingForm.thirdPartyRobotCtiList, this.settingForm.thirdPartyRobotCtiList.length, {
            robotId: null,
            itemList: this.categoryList.map(item => item.itemId)
        });
    }
    deleteBotLine(index: number) {
        this.settingForm.thirdPartyRobotCtiList.splice(index, 1);
    }
    async getCtiByRgUnfold() {
        // 直接展示所有数据，不考虑分页
        try {
            const res = await api.rgApi.getCtiByRgUnfold({
                cn: 1,
                sn: 999,
                rgId: this.rgId
            });
            const { code, data } = res;
            if (code === 200) {
                this.categoryList = data.items || [];
            }
        } catch (e) {
            console.log(e);
        }
    }
    async getDxSetting() {
        const res = await api.ticketApi.getDxSetting(this.rgId);
        const { data, code } = res;
        if (code === 200 && data) {
            this.settingForm = data;
            if (!this.settingForm?.thirdPartyRobotCtiList?.length) {
                this.settingForm.thirdPartyRobotCtiList = [
                    {
                        robotId: null,
                        itemList: []
                    }
                ];
            }
        }
    }
    validateBotList(): Promise<boolean> {
        return new Promise(resolve => {
            const isValid = this.settingForm.thirdPartyRobotCtiList.every(item => {
                return item.robotId && item.itemList.length > 0;
            });
            resolve(isValid);
        });
    }
    async change(type: string) {
        if (type === 'ticketReminderTime' && !this.settingForm[type]) {
            this.$mtd.message.error('提醒时间需大于0');
            this.getDxSetting();
            return;
        }
        const requestParam: any = {};
        requestParam[type] = this.settingForm[type];
        if (type === 'thirdPartyRobot') {
            const valid = await this.validateBotList();
            if (valid) {
                this.showErrorTip = false;
                requestParam.inviteThirdPartyRobotSwitch = true;
                requestParam.thirdPartyRobotCtiList = this.settingForm.thirdPartyRobotCtiList;
            } else {
                this.showErrorTip = true;
                return;
            }
        }
        try {
            const res = await api.ticketApi.setDxSetting({
                rgId: this.rgId,
                ...requestParam
            });
            const { code } = res;
            if (code === 200) {
                this.$mtd.message.success('保存成功');
                this.getDxSetting();
            }
        } catch (error) {
            this.getDxSetting();
        }
    }
    onRobotBindItemChanged(item, data) {
        item.itemList = data;
    }
    onRobotSwitch(val) {
        if (!val) {
            this.change('inviteThirdPartyRobotSwitch');
        }
    }
}
